import { render, staticRenderFns } from "./daftar_kiraanPSM.vue?vue&type=template&id=1cbf5192&scoped=true&"
import script from "./daftar_kiraanPSM.vue?vue&type=script&lang=js&"
export * from "./daftar_kiraanPSM.vue?vue&type=script&lang=js&"
import style0 from "./daftar_kiraanPSM.vue?vue&type=style&index=0&id=1cbf5192&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cbf5192",
  null
  
)

export default component.exports